const documentConfig = {
    title: "Document",
    customAddText: "Add Document",
    api: "Document",
    name: "Document",
    idProperty: "DocumentId",
    module: "Document",
    joinColumn: "AssociationId",
    showHistory: false,
    standard: true,
    showBreadcrumbs: false,
    navigateBack: -1,
    columns: [
        {
            field: "DocumentGroupId",
            label: "Document Group",
            type: "select",
            lookup: "DocumentGroup",
            width: '200',
            readOnly: true
        },
        {
            field: "DocumentTypeId",
            label: "Document Type",
            type: "select",
            lookup: 'DocumentType',
            required: true,
            width: '200'
        },
        {
            field: "AssociationId",
            label: null,
            type: "string",
            gridLabel: null,
            readOnly: true
        },
        {
            field: "DocumentName",
            label: "Document Name",
            type: "string",
            required: true,
            width: 200,
            max: 50
        },
        {
            field: "DocumentRev",
            label: "Document Revision",
            type: 'string',
            width: 200,
            max: 50
        },
        {
            field: "FileName",
            label: "File Name",
            hideInAddGrid: true,
            readOnly: true,
            width: 180,
            max: 50
        },
        {
            field: "ExternalLink",
            gridLabel: "External Link",
            type: "boolean",
            label: null
        },
        {
            field: "DocumentLink",
            label: "Document Link",
            required: true,
            type: "fileUpload",
            width: 200,
            max: 500
        },
        {
            field: "Notes",
            label: "Notes",
            type: "string",
            multiline: true,
            width: 300,
            rows: 5,
            max: 2000,
            variant: 'outlined'
        }
    ]
};

export default documentConfig;